import {
  FETCH_ORDERS,
  FETCH_ORDERS_SUCCESS,
  FETCH_ORDERS_FAILED
} from '../../types';

const initialState = {
  orders: {},
  isLoading: false,
  errors: {},
  error: false
}

const fetchOrdersReducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_ORDERS:
      return {
        ...state,
        isLoading: true,
          orders: action.payload
      }
      case FETCH_ORDERS_SUCCESS:
        return {
          ...state,
          isLoading: false,
            orders: action.payload
        }
        case FETCH_ORDERS_FAILED:
          return {
            ...state,
            isLoading: false,
              errors: action.payload,
              error: true
          }
          default:
            return {
              ...state
            };
  }
}

export default fetchOrdersReducer;
